<template>
  <div class="row padd-0">
    <div class="col-12 padd-0">
      <div class="row">
        <div class="col-5">
          <div class="notifTimeClass">Created: {{createdTime}}</div>
        </div>
        <div class="col-1 customerIdClass">
          <!-- Status: -->
          <div
            :class="noteStatus == 'active' ? 'activStatusColorClass' : 'inactiveStatusColorClass'"
          >{{noteStatus}}</div>
        </div>
        <div class="col-2" style="padding-left: 2px; padding-right: 2px;">
          <div>
            <b-button
              v-b-modal="'modalViewChat' + note.ssId.substring(0,7)"
              size="sm"
              variant="outline-primary"
            >View chat</b-button>
          </div>
        </div>

        <div v-if="!isInProcess" class="col-2"></div>

        <div class="col-2" v-if="showingActive">
          <div>
            <b-button
              size="sm"
              variant="outline-primary"
              @click="isInProcess ? confirmFinishing() : $emit('ProcessStatusChanged', {ssId: note.ssId, status: 'in_process', evRem: false})"
            >{{isInProcess ? 'Mark as processed' : 'Start processing'}}</b-button>
          </div>
        </div>
        <div v-if="isInProcess && showingActive" class="col-2">
          <b-button
            size="sm"
            variant="danger"
            @click="$emit('ProcessStatusChanged', {ssId: note.ssId, status: 'active', evRem: false})"
          >Cancel processing</b-button>
        </div>
      </div>

      <div class="row" v-if="notifications.find(el => el.processed_status == 'aborted')">
        <!--  -->
        <div
          class="col-12 abortwarning"
        >This case was taken in process but NOT FINISHED by {{RetrieveAdmin(notifications.find(el => el.processed_status == 'aborted').processed_by)}}</div>
      </div>
      <!-- color:darkslateblue; -->
      <div class="row" style="padding-top:25px; color:black;">
        <div class="col-4">
          <div class="row" style="padding-top:10px;">
            <div class="col-2 personIconStyle">
              <b-icon class="personIconSize h2 mb-2" icon="person-square"></b-icon>
            </div>
            <div class="col-10 pl0 pr0 clientInfo-namebox">
              <div class="padTopBot">{{clientId}}</div>
              <div class="displayInline padTopBot">{{clientName}}</div>
              <!-- <div class="displayInline padTopBot">{{activUserInfo.lastName}}</div> -->
            </div>
          </div>
        </div>
        <div class="col-2">
          <div v-b-toggle="'phn-' + note.ssId" class="m-1 no-button-style">
            <b-icon v-if="phones.length > 0 && phones[0]" icon="phone"></b-icon>
            {{phones[0] || ''}} {{note.verified_contacts ? '(confirmed)' : ''}}
          </div>

          <!-- Element to collapse -->
          <b-collapse :id="'phn-' + note.ssId" v-if="phones.length > 1">
            <div v-for="phn in phones" :key="phn">{{phn}}</div>
          </b-collapse>
        </div>
        <div class="col-4">
          <div v-b-toggle="'eml-' + note.ssId" class="m-1 no-button-style">
            <b-icon v-if="emails.length > 0 && emails[0]" icon="envelope"></b-icon>
            {{emails[0] || ''}} {{note.verified_contacts ? '(confirmed)' : ''}}
          </div>

          <!-- Element to collapse -->
          <b-collapse :id="'eml-' + note.ssId" v-if="emails.length > 1">
            <div v-for="eml in emails" :key="eml">{{eml}}</div>
          </b-collapse>
        </div>
        <div class="col-2" v-if="emailAllowed">
          <div style="padding-top:10px;">
            Client
            <span
              :style="emailAllowed ? 'color:green; font-weight:bold;' : 'color: red;font-weight:bold;'"
            >{{emailAllowed ? 'agreed' : 'refused'}}</span> to receive emails
          </div>
        </div>
      </div>
      <div class="row note-style-main">
        <div class="col-4">Vehicle</div>
        <div class="col-8">Notification type and details</div>
      </div>

      <NotifData
        v-for="(vh, index) in vhs"
        :notifications="notifications.filter(el => vh == 'undef' ? el.vehicle.id == '' : el.vehicle.id == vh)"
        :key="'note-detail-' + index"
      />

      <!-- MODALS -->

      <b-modal
        size="xl"
        :id="'modalViewChat' + note.ssId.substring(0,7)"
        header-class="headerModalClass"
        centered
        hide-footer
        :title="`${clientName} (${clientId})`"
      >
        <viewChatWindow
          :ssId="note.ssId"
          :colId="'ch-hist-' + note.ssId.substring(0,6)"
          :key="'ch-hist-ky-' + note.ssId.substring(0,6)"
        />
      </b-modal>

      <b-modal
        id="modal-processed"
        ref="modal-processed"
        centered
        title="Confirm"
        ok-title="Confirm"
        @ok="$emit('ProcessStatusChanged', {ssId: note.ssId, status: 'processed', evRem: false})"
        @cancel="$emit('ProcessStatusChanged', {ssId: note.ssId, status: 'processed', evRem: true})"
      >
        <template v-slot:modal-footer="{ ok, cancel, close }">
          <b-button
            size="sm"
            variant="success"
            @click="ok()"
          >{{notifications.find(el => el.note_type == 'appointment') ? 'Added to DMS' : 'Confirm'}}</b-button>
          <b-button
            size="sm"
            variant="danger"
            @click="cancel()"
            v-if="notifications.find(el => el.note_type == 'appointment')"
          >Not added to DMS</b-button>
          <!-- Button with custom close trigger value -->
          <b-button size="sm" variant="outline-secondary" @click="close()">Cancel</b-button>
        </template>
        <div v-if="!notifications.find(el => el.customerId == undefined || el.customerId == '')">
          <p class="my-4">Please confirm this notification processed</p>
        </div>
        <div v-if="notifications.find(el => el.customerId != undefined && el.customerId != '')">
          <div class="row">
            <div class="col-12">Please confirm following information processed :</div>
          </div>

          <div class="row" style="padding-top: 20px;">
            <div class="col-3">Client:</div>
            <div
              class="col-9"
              style="font-weight:bold;text-align: left;"
            >{{clientName}} ({{clientId}})</div>
          </div>
          <div
            class="row"
            style="padding-top: 10px;"
            v-if="notifications.find(el => el.vehicle.id != '' && el.vehicle.id != 'undef')"
          >
            <div class="col-3">Requests for vehicle(s):</div>
            <div class="col-9">
              <div
                class="row"
                style="font-weight:bold;text-align: left;"
                v-for="(vhh, vhhKey) in vhs"
                :key="vhhKey"
              >
                <div
                  class="col-12"
                  v-if="vhh != 'undef'"
                >{{notifications.find(el => el.vehicle.id == vhh).vehicle.make}} {{notifications.find(el => vhh == el.vehicle.id).vehicle.model}} ({{notifications.find(el => vhh == el.vehicle.id).vehicle.year}})</div>
              </div>
            </div>
          </div>
          <div
            class="row"
            style="padding-top: 35px;"
            v-if="notifications.find(el => el.ssId == note.ssId && el.note_type == 'appointment')"
          >
            <div class="col-12 red-bold">Please, confirm appointment registered to DMS</div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import viewChatWindow from "./../additionalComponents/viewChatWindow.vue";
import NotifData from "./NotifData.vue";
export default {
  name: "ClientNotification",
  components: {
    viewChatWindow,
    NotifData
  },
  props: {
    notifications: Array,
    note: Object,
    maId: String,
    showingActive: Boolean,
    alladmins: Array
  },
  data() {
    return {};
  },

  computed: {
    vhs() {
      let r = [];
      for (let i in this.notifications) {
        let el = this.notifications[i];
        let vehId = el.vehicle.id || "undef";
        if (!r.find(elem => elem === vehId)) {
          r.push(vehId);
        }
      }
      return r;
    },
    createdTime() {
      return this.notifications && this.notifications.length > 0
        ? new Date(this.notifications[0].created_time.seconds * 1000)
            .toString()
            .split("GMT")[0]
        : "";
    },
    noteStatus() {
      return this.notifications.find(el => el.status == "active")
        ? "active"
        : this.notifications && this.notifications.length > 0
        ? this.notifications[0].status
        : "";
    },
    isInProcess() {
      return this.note.processed_status == "in_process";
    },
    clientId() {
      let cid = this.notifications.find(el => el.customerId != "");
      return !cid
        ? "Not Identified"
        : cid.customerId.includes("new_") ||
          cid.customerId.substring(0, 1) == "_"
        ? "New Customer"
        : "#" + cid.customerId;
    },
    clientName() {
      let cname = this.notifications.find(el => el.customerName != "");
      return cname ? cname.customerName : "";
    },
    phones() {
      return this.FormContacts("phone");
    },
    emails() {
      return this.FormContacts("email");
    },
    emailAllowed() {
      let r = undefined;
      let ea = "";
      if (this.note.verified_contacts) {
        ea = this.note.verified_contacts.emailAllowed;
      }

      if (ea != undefined && ea != null && ea !== "") {
        r = ea;
      } else {
        let er = this.notifications.find(
          el =>
            el.verified_contacts && el.verified_contacts.emailAllowed === true
        );
        if (er != undefined) {
          r = true;
        } else {
          r = false;
        }
      }

      return r;
    }
  },

  watch: {},

  mounted() {},

  methods: {
    VehHelpFilter(el, vh) {
      return vh == "undef" ? el.vehicle.id == "" : el.vehicle.id == vh;
    },
    confirmFinishing() {
      this.$refs["modal-processed"].show();
    },
    FormContacts(m) {
      let arr = [];
      this.notifications.forEach(n => {
        let p =
          n.verified_contacts && n.verified_contacts[m]
            ? n.verified_contacts[m].toString()
            : "";
        if (p && !arr.includes(p)) {
          arr.push(p);
        }
      });
      if (this.note.verified_contacts) {
        if (this.note.verified_contacts[`${m}s_on_file`]) {
          arr = arr.concat(
            this.note.verified_contacts[`${m}s_on_file`].filter(
              item => arr.indexOf(item) < 0
            )
          );
        }
        if (this.note.verified_contacts[m]) {
          let ph = this.note.verified_contacts[m].toString();
          let ind = arr.findIndex(el => el == ph);
          if (ind > -1) {
            arr.splice(ind, 1);
          }
          arr.unshift(ph);
        }
      }
      return arr;
    },
    RetrieveAdmin(id) {
      let adm = this.alladmins.find(el => el.id == id) || "";
      return adm != ""
        ? `${adm.userOptionalName} (${adm.email})`
        : "another representative";
    }
  }
};
</script>
<style>
.padd-0 {
  padding: 0;
}
.notifTimeClass {
  text-align: left;
}
.customerIdClass {
  text-align: left;
  font-size: 18px;
}
.activStatusColorClass {
  color: green;
  font-weight: bold;
  display: inline;
}
.inactiveStatusColorClass {
  color: orangered;
  font-weight: bold;
  display: inline;
}

.abortwarning {
  font-weight: bold;
  color: red;
  margin-top: 15px;
}
.personIconStyle {
  padding-right: 0;
}
.personIconSize {
  font-size: 45px;
}
.clientInfo-namebox {
  text-align: left;

  font-weight: bold;
  font-size: 18px;
}
.no-button-style,
.no-button-style:hover,
.no-button-style,
.no-button-style:focus {
  background: transparent;
  border: 0px solid transparent;
  padding-top: 10px;
  font-weight: bold;
  font-size: 18px;
}
.no-button-style:hover {
  cursor: pointer;
}
.note-style-main {
  margin-top: 20px;
  border: 1px solid lightgrey;
  font-weight: 18px;
  background: #fed000;
}
.headerModalClass .modal-title {
  font-weight: bold;
  color: rgb(3, 0, 153);
}
.red-bold {
  font-weight: bold;
  color: darkred;
}
@media (min-width: 576px) and (max-width: 992px) {
  .clientInfo-namebox {
    text-align: left;
    font-weight: bold;
    font-size: 18px;
    padding-left: 35px;
  }
}
</style>